import { StockModuleLayout } from "@features/stock";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock")({
  staticData: {
    title: "Stock",
    permission: "stock.dashboard.view",
    module: "stock",
    section: "Stock",
    order: 45,
    showInNav: false,
  },
  component: StockModuleLayout,
});
